import { useEffect } from "react";
import { X } from "lucide-react";
import { LoginForm } from "../pages/LoginForm";

/** Anmeldung als Überlagerung, ohne die Seite zu verlassen.
 *
 *  Der Punkt ist genau das: wer auf der Ablage steht und sich anmeldet, will
 *  danach auf der Ablage stehen — nicht auf dem Dashboard. Deshalb schließt
 *  sich der Dialog nach dem Erfolg nur; die Route bleibt, wo sie war, und die
 *  Seite rendert sich mit den nun erlaubten Daten neu. */
export function LoginDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className="login-modal-backdrop" onClick={onClose}>
      <div
        className="login-modal"
        role="dialog"
        aria-modal="true"
        aria-label="Sign in"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="login-modal-close" onClick={onClose} aria-label="Close">
          <X className="icon-svg" />
        </button>
        <LoginForm onDone={onClose} />
      </div>
    </div>
  );
}
